module.exports = {
	model: {
		dateFrom: null,
		dateTo: null,
		config: {
			slim: false
		}
	},

	events: {
		toggleInfinity: {
			type: 'click',
			selector: 'button',
			action: function(event){
				event.stopImmediatePropagation();
				var self = event.data.component;
				var $target = $(event.target).closest('button');
				if($target.hasClass('from')){
					self.onChange(null, undefined);
				} else if($target.hasClass('to')){
					self.onChange(undefined, null);
				}
			}
		}
	},

	methods: {
		onChange: function(from, to, forceValueChanged = false){
			var self = this;
			var valueChanged = forceValueChanged || false;

			if(from !== undefined){
				from = from || null;

				if(from !== this.model.dateFrom){
					forceValueChanged = true;
					this.model.dateFrom = from;
					var fromAirDateTimePicker = getComponent(this.$.find('> .from .base_form_fields_air-datetime-picker'));

					if(from === null){
						this.$.find('> .from > button').addClass('active');
						if(fromAirDateTimePicker){
							fromAirDateTimePicker.setDate(null);
						}
					} else {
						this.$.find('> .from > button').removeClass('active');
						if(fromAirDateTimePicker.model.dataDATE !== from){
							fromAirDateTimePicker.setDate(from);
						}
					}
				}
			}

			if(to !== undefined){
				to = to || null;

				if(to !== this.model.dateTo){
					forceValueChanged = true;
					this.model.dateTo = to;
					var toAirDateTimePicker = getComponent(this.$.find('> .to .base_form_fields_air-datetime-picker'));

					if(to === null){
						this.$.find('> .to > button').addClass('active');
						if(toAirDateTimePicker){
							toAirDateTimePicker.setDate(null);
						}
					} else {
						this.$.find('> .to > button').removeClass('active');
						if(toAirDateTimePicker.model.dataDATE !== to){
							toAirDateTimePicker.setDate(to);
						}
					}
				}
			}

			if(this.model.dateFrom !== null && this.model.dateTo !== null && this.model.dateFrom > this.model.dateTo) {
				this.onChange(this.model.dateTo, this.model.dateFrom, true);
			} else if(forceValueChanged) {
				this.parent(function(parentComponent){
					parentComponent.trigger('onChildChanged', {
						fieldCode: self.model.fieldCode,
						value: {
							from: self.model.dateFrom,
							to: self.model.dateTo
						}
					});
				});
			}
		},

		onBeforeRender: function(){
			var initDateRange = this.model.dataJSON || {};
			this.model.dateFrom = initDateRange.from || null;
			this.model.dateTo = initDateRange.to || null;
		}
	},

	hooks: {
		onChildChanged: function($element, options){
			if(options.fieldCode === 'from'){
				this.onChange(options.value, undefined);
			} else if (options.fieldCode === 'to'){
				this.onChange(undefined, options.value);
			}
		}
	}
};
